import React from "react";
import {QRCode} from "react-qrcode-logo";

export default function QRGenerator({data}) {
        return <QRCode value={data.value} fgColor={"#000000"} id={data.id} enableCORS={true} ecLevel={"H"} size={300}
                               logoImage="/images/darthelfer.png" logoHeight="100" logoWidth="80" logoOpacity={1}/>
}
